import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/subtemplates/publicTemplates/`;
export const QueryKey = () => ['v3', 'subtemplates', 'publicTemplates'];
export type Payload = never;
export type Response = Models.SubscriptionTemplates.PublicTemplate[];
